import { useState } from 'react';
import ListingImage from '@Components/Listings/ListingImage';
import TranslationText from '@Components/Utilities/TranslationText';
import ListingDisplayLocation from '@Components/Shared/Listings/ListingDisplayLocation';
import { sandhillsRequest, truncateString } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const StolenEquipmentListCard = (props) => {

    const [showDeleteMessage, setShowDeleteMessage] = useState(false);
    const routes = useRecoilValue(atoms.routes);

    const editStolenEquipment = (stolenEquipment) => {
        window.location = routes.StolenEquipmentVendor + '?ListingID=' + stolenEquipment.Id;
    };

    const deleteStolenEquipment = (stolenEquipment) => {
        sandhillsRequest({
            url: routes.SaveStolenEquipment,
            method: 'post',
            data: {
                Id: stolenEquipment.Id,
                Crmid: stolenEquipment.InternalCRMID,
                Action: 2
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then(() => {
            setShowDeleteMessage(true);
        });
    };

    return (
        <div className='ListingParentElement'>
            <div className='list-listing listing-data-selector' data-listing-id={props.Id}>
                <div>
                    <div className='listing-top'>
                        <div className='listing-top-left'>
                            <ListingImage
                                {...props.StolenImageModel}
                                AbsolutePathBaseUrl=''
                                ListingId={props.Id}
                                DetailUrl={props.DetailUrl}
                                LinkTarget={props.LinkTarget}
                                ForceLoadImages={props.ForceLoadImages}
                                DispatchListings={props.DispatchListings}
                                ListingTitle={props.StolenEquipmentTitle}
                            >
                                {props.FormattedAddedOnTime && <span className='add-update-time'><strong><TranslationText tKey='Sandhills.Added' />: </strong>{props.FormattedAddedOnTime}</span>}
                                {props.FormattedUpdatedOnTime && <span className='add-update-time'><strong><TranslationText tKey='Sandhills.updated' />: </strong>{props.FormattedUpdatedOnTime}</span>}
                            </ListingImage>
                            <div className='listing-main-stats'>
                                <div className='list-listing-title' data-score={props.ElasticScore}>
                                    {props.DetailUrl && props.StolenEquipmentTitle ?
                                        <a href={props.DetailUrl} className='list-listing-title-link' target={props.LinkTarget}>
                                            <h2 className='listing-portion-title'>{props.StolenEquipmentTitle}</h2>
                                        </a> : props.StolenEquipmentTitle ?? <h2 className='listing-portion-title'>{props.StolenEquipmentTitle}</h2>}
                                </div>
                                <div className='listing-category'>{props.DisplayCategoryName}</div>
                                <div className='price-container'>
                                    {props.StolenLocation && <ListingDisplayLocation {...props.StolenLocation} />}
                                </div>
                                <div className='spec-container'>
                                    <span className='spec-label'><TranslationText tKey='sandhills.status' />:</span>
                                    <span className='spec-value'>{props.StolenStatus}</span>
                                </div>
                                <div className='spec-container'>
                                    <span className='spec-label'><TranslationText tKey='sandhills.tradepubwebsite.mvc.serial number' />:</span>
                                    <span className='spec-value'>{props.SerialNumber}</span>
                                </div>
                            </div>
                        </div>
                        <div className='listing-top-right'>
                            {/*props.ShowDealer && <div className='listing-dealer-info'>
                                <h5 className='dealer-name'>{props.DealerName}</h5>
                                <div className='dealer-data'>{props.DealerLocation}</div>
                                {props.DealerPhoneNumberFormatted && props.DealerPhoneNumberUnformatted &&
                                    <div className='dealer-data'>
                                        <span><TranslationText tKey='sandhills.phone' />:</span>
                                        <a href={'tel:' + props.DealerPhoneNumberUnformatted} className='phone-link'>
                                            {props.DealerPhoneNumberFormatted}
                                        </a>
                                    </div>}
                            </div>*/}
                            <div className='listing-dealer-info'>
                                {(props.ShowEmployeeOnlyInfo || props.ShowUpdateDelete) &&
                                    <div className='stolen-equipment-update-delete'>
                                        <span className='stolen-equipment-edit'>
                                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter') editStolenEquipment(props) }} onClick={() => editStolenEquipment(props)}><i className='fas fa-edit'></i> <TranslationText tKey='Sandhills.Edit' /></a>
                                        </span>
                                        <span className='stolen-equipment-delete'>
                                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter') deleteStolenEquipment(props) }} onClick={() => deleteStolenEquipment(props)}><i className='fas fa-trash'></i> <TranslationText tKey='Sandhills.Delete' /></a>
                                        </span>
                                    </div>}
                                {showDeleteMessage &&
                                    <div className='success' style={{ fontSize: '12px' }}>
                                        <TranslationText tKey='Sandhills.SuccessfullyDeletedStolenEquipment' />
                                    </div>}
                                {props.LEAName && <h5 className='dealer-name'>{props.LEAName}</h5>}
                                {props.LEAPhoneNumberFormatted && props.LEAPhoneNumberUnformatted &&
                                    <div className='dealer-data'>
                                        <a href={'tel:' + props.LEAPhoneNumberUnformatted} className='phone-link'>
                                            <strong>{props.LEAPhoneNumberFormatted}</strong>
                                        </a>
                                    </div>}
                            </div>
                            <span><span dangerouslySetInnerHTML={{ __html: props.DetailButtonHTML }} /></span>
                        </div>
                    </div>
                    <div className='listing-bottom'>
                        {props.TheftDetail &&
                            <div className='listing-description-text' tabindex='0'>
                                {props.TheftDetail.length > props.ListPageDescriptionMaxLength ?
                                    <div className='listing-description'>
                                        {truncateString(props.TheftDetail, props.ListPageDescriptionMaxLength)}
                                        <a className='more' href={props.DetailUrl} aria-label={props.openDetailPageInNewTab ? translator.translate('sandhills.seemoredetails') + " - " + props.AriaLabelTitle + " (" + translator.translate('sandhills.opensinanewtab') + ")" : translator.translate('sandhills.seemoredetails') + " - " + props.AriaLabelTitle}><TranslationText tKey='sandhills.seemoredetails' /> </a>
                                    </div> : <div className='listing-description'>
                                        {props.TheftDetail}
                                    </div>}
                            </div>}
                    </div>
                </div>
            </div>
            <div className='list-listing-mobile listing-data-selector' data-listing-id={props.Id}>
                <div className='list-listing-title' data-score={props.ElasticScore}>
                    {props.DetailUrl && props.StolenEquipmentTitle ?
                        <a href={props.DetailUrl} className='list-listing-title-link' target={props.LinkTarget}>
                            <h2 className='listing-portion-title'>{props.StolenEquipmentTitle}</h2>
                        </a> : props.StolenEquipmentTitle ?? <h2 className='listing-portion-title'>{props.StolenEquipmentTitle}</h2>}
                </div>
                <div className='listing-category'>{props.DisplayCategoryName}</div>
                <ListingImage
                    {...props.StolenImageModel}
                    AbsolutePathBaseUrl=''
                    ListingId={props.Id}
                    DetailUrl={props.DetailUrl}
                    LinkTarget={props.LinkTarget}
                    ForceLoadImages={props.ForceLoadImages}
                    DispatchListings={props.DispatchListings}
                    ListingTitle={props.StolenEquipmentTitle}
                >
                    {props.FormattedAddedOnTime && <span className='add-update-time'><strong><TranslationText tKey='Sandhills.Added' />: </strong>{props.FormattedAddedOnTime}</span>}
                    {props.FormattedUpdatedOnTime && <span className='add-update-time'><strong><TranslationText tKey='Sandhills.updated' />: </strong>{props.FormattedUpdatedOnTime}</span>}
                </ListingImage>
                <div className='listing-dealer-info'>
                    {/*props.ShowDealer &&
                        <> 
                            {props.DealerPhoneNumberFormatted && props.DealerPhoneNumberUnformatted &&
                                <div className='dealer-phone-container'>
                                    <a href={'tel:' + props.DealerPhoneNumberUnformatted} className='dealer-phone-call'>
                                        <i className='material-icons gtm-noclick'>phone</i>
                                        <span className='dealer-phone gtm-noclick'>{props.DealerPhoneNumberFormatted}</span>
                                    </a>
                                    {props.IsDealerPhoneNumberTextEnabled &&
                                        <a href={'sms:' + props.DealerPhoneNumberUnformatted} className='dealer-phone-text'>
                                            <span className='text-icon gtm-noclick'></span>
                                            <span className='dealer-phone gtm-noclick'>{props.DealerPhoneNumberFormatted}</span>
                                        </a>}
                                </div>}
                            <div className='spec-container'>
                                <span className='spec-label'><TranslationText tKey='sandhills.contact' />:</span>
                                <span className='spec-value'>{props.DealerName}</span>
                            </div>
                            <div className='spec-container dealer-location'>
                                <span className='spec-label'>Location:</span><span className='spec-value'>{props.DealerLocation}</span>
                            </div>
                        </>*/}
                    {props.LEAName &&
                        <>
                            {props.LEAPhoneNumberFormatted && props.LEAPhoneNumberUnformatted &&
                                <div className='dealer-phone-container'>
                                    <a href={'tel:' + props.LEAPhoneNumberUnformatted} className='dealer-phone-call'>
                                        <i className='material-icons gtm-noclick'>phone</i>
                                        <span className='dealer-phone gtm-noclick'>{props.LEAPhoneNumberFormatted}</span>
                                    </a>
                                </div>}
                            <div className='spec-container'>
                                <span className='spec-label'><TranslationText tKey='sandhills.lawenforcementagency' />:</span>
                                <span className='spec-value'>{props.LEAName}</span>
                            </div>
                        </>}
                    {props.StolenLocation && <ListingDisplayLocation {...props.StolenLocation} IsMobile OneLine />}
                </div>
                <div className='specs-container'>
                    <div className='spec-container'>
                        <span className='spec-label'><TranslationText tKey='sandhills.status' />:</span>
                        <span className='spec-value'>{props.StolenStatus}</span>
                    </div>
                    <div className='spec-container'>
                        <span className='spec-label'><TranslationText tKey='sandhills.tradepubwebsite.mvc.serial number' />:</span>
                        <span className='spec-value'>{props.SerialNumber}</span>
                    </div>
                </div>
                {props.TheftDetail &&
                    <div>
                        {props.TheftDetail.length > props.ListPageDescriptionMaxLength ?
                            <div className='listing-description'>
                                {truncateString(props.TheftDetail, props.ListPageDescriptionMaxLength)}
                                <a className='more' href={props.DetailUrl} aria-label={props.openDetailPageInNewTab ? translator.translate('sandhills.seemoredetails') + " - " + props.AriaLabelTitle + " (" + translator.translate('sandhills.opensinanewtab') + ")" : translator.translate('sandhills.seemoredetails') + " - " + props.AriaLabelTitle}><TranslationText tKey='sandhills.seemoredetails' /> </a>
                            </div> : <div className='listing-description'>
                                {props.TheftDetail}
                            </div>}
                    </div>}
                <span dangerouslySetInnerHTML={{ __html: props.DetailButtonHTML }} />
            </div>
        </div>
    );
};

export default StolenEquipmentListCard;